import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "PokerSpinAndGoWidget" */ './PokerSpinAndGoWidget'),
  modules: ['./PokerSpinAndGoWidget'],
  loading: () => <div />
});

export default LoadableWidget;
